export default function imageToDataURI (file) {
  if (!file || !(file instanceof File)) {
    return Promise.resolve('')
  }

  return new Promise((resolve) => {
    const fileReader = new FileReader()
    fileReader.addEventListener('load', (e) => resolve(e.target.result))
    fileReader.readAsDataURL(file)
  })
}

/* global File, FileReader */



// WEBPACK FOOTER //
// ./src/helpers/imageToDataURI.js